export enum MessageTypeEnum {
  info = 'info',
  danger = 'danger',
  success = 'success',
  error = 'error',
}
